
import Vue from 'vue'
export default Vue.extend({
  name: 'whitelist-id-layout'
})
